import {InquiryStatusType, inquiryStatusTypeDecoder} from './InquiryStatusType'
import {LocalDateTime} from 'js-joda'
import {inquiryStatusDecoder, InquiryStatus} from './InquiryStatus'
import {Decoder, object, field, number, string} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface InquiryStatusChange {
    readonly id: number
    readonly inquiryId: number
    readonly statusType: InquiryStatusType
    readonly newStatus: InquiryStatus
    readonly comment: string
    readonly created: LocalDateTime
}

export function inquiryStatusChangeDecoder(): Decoder<InquiryStatusChange> {
    return object({
        id: field('id', number()),
        inquiryId: field('inquiryId', number()),
        statusType: field('statusType', inquiryStatusTypeDecoder()),
        newStatus: field('newStatus', inquiryStatusDecoder()),
        comment: field('comment', string()),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryStatusChange.ts